<template>
  <button
    type="button"
    class="theme_switcher"
    :class="{ dark: isDark, light_on_dark: onDark }"
    :title="title"
    :aria-label="title"
    @click="toggle"
  >
    <!-- Луна: показываем в светлой теме (переключит на тёмную) -->
    <svg
      v-if="!isDark"
      class="theme_icon"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z" />
    </svg>
    <!-- Солнце: показываем в тёмной теме (переключит на светлую) -->
    <svg
      v-else
      class="theme_icon"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <circle cx="12" cy="12" r="4" />
      <path
        d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41"
      />
    </svg>
    <span v-if="withLabel" class="theme_label">{{ title }}</span>
  </button>
</template>

<script>
import { isDarkTheme, toggleTheme, onThemeChange } from '@/helpers/base/theme'
import { makeEvent } from '@/helpers/base/amplitude'

export default {
  name: 'ThemeSwitcher',
  props: {
    // подпись рядом с иконкой (в боковом меню)
    withLabel: { type: Boolean, default: false },
    // кнопка стоит на тёмной панели (боковое меню) — другие цвета
    onDark: { type: Boolean, default: false },
  },
  data() {
    return {
      isDark: isDarkTheme(),
    }
  },
  computed: {
    title() {
      return this.isDark ? this.$t('theme.light') : this.$t('theme.dark')
    },
  },
  mounted() {
    this.unsubscribe = onThemeChange(theme => {
      this.isDark = theme === 'dark'
    })
  },
  beforeUnmount() {
    if (this.unsubscribe) this.unsubscribe()
  },
  methods: {
    toggle() {
      const theme = toggleTheme()
      makeEvent('toggle theme', { theme })
    },
  },
}
</script>

<style scoped>
.theme_switcher {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 6px;
  border-radius: 7px;
  background: none;
  color: var(--text-secondary2);
  cursor: pointer;
  transition: color 0.2s ease, background-color 0.2s ease;
  line-height: 1;
}
.theme_switcher:hover {
  color: var(--text-primary);
  background: var(--bg-hover);
}
.theme_icon {
  display: block;
  flex-shrink: 0;
}
.theme_label {
  font-size: 14px;
  line-height: 19px;
  white-space: nowrap;
}

/* на тёмной боковой панели */
.theme_switcher.light_on_dark {
  color: var(--text-secondary3);
  border-radius: 0;
}
.theme_switcher.light_on_dark:hover {
  color: #ffffff;
  background: none;
}
</style>
